import { axiosInstance } from "./api_instance";


export default async function heartBeatAPI(postType) {

    try {
        const response = await axiosInstance.get(`/auth/heartbeat`)
        if(response.status === 200){
            return response
        }

    } catch (error) {
        let msg = await error?.response?.data.error.message
       
        return msg
    }
} 